import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Pipes
import { SmartValuePipe } from './customPipes/smartValue.pipe';
import { StringToDateFormatPipe } from './customPipes/StringToDateFormat.pipe';
import { MillisecondsFormatterPipe } from './customPipes/milliseconds-formatter.pipe';

// Components
import { SideNavBarComponent } from './side-nav-bar/side-nav-bar.component';
import { CompletionBarComponent } from './issueCompletionBar.component';
import { ViewDocsModalComponent } from './view-docs-modal/view-docs-modal.component';
import { SelectSignatoriesComponent } from './select-signatories/select-signatories.component';


import { CreditRatingDetailsComponent } from './credit-rating-details/credit-rating-details.component';
import { UploadButtonComponent } from './upload-button/upload-button.component';
import { UploadImageModalComponent } from './upload-image-modal/upload-image-modal.component';
import { ViewCpDocumentsComponent } from './view-cp-documents/view-cp-documents.component';
import { ActionablesComponent } from './actionables/actionables.component';
import { LogoutModalComponent } from './logout-modal/logout-modal.component';
import { UploadSignedDocumentsComponent } from './upload-signed-documents/upload-signed-documents.component';
import { IciciSelectInputComponent } from './icici-select-input/icici-select-input.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { RejectModalComponent } from './reject-modal/reject-modal.component';
import {
  ConfirmDialogBoxModalComponent
} from './confirm-dialog-box-modal/confirm-dialog-box-modal.component';
import { IeBannerComponent } from './ie-banner/ie-banner.component';
import { SimpleSigningModalComponent } from './simple-signing-modal/simple-signing-modal.component';
import { IssueListingSidepanelComponent } from './issue-listing-sidepanel/issue-listing-sidepanel.component';
import { ListingExtradataModalComponent } from './listing-extradata-modal/listing-extradata-modal.component';
import { ResendDocsLinkComponent } from './resend-docs-link/resend-docs-link.component';
import { BidSidepanelComponent } from './bid-sidepanel/bid-sidepanel.component';
import { BidFormComponent } from './bid-sidepanel/bid-form/bid-form.component';
import { DateAdditionalDataComponent } from './date-additional-data/date-additional-data.component';
import {
  UploadSignDocsSidepanelComponent
} from './upload-signed-documents/upload-sign-docs-sidepanel/upload-sign-docs-sidepanel.component';
import {
  UploadSignDocsFormComponent
} from './upload-signed-documents/upload-sign-docs-form/upload-sign-docs-form.component';
import {
  UploadSignedDocsConfirmComponent
} from './upload-signed-documents/upload-signed-docs-confirm/upload-signed-docs-confirm.component';
import { PaginationComponent } from './pagination/pagination.component';
import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    OverlayscrollbarsModule,
    NgSelectModule
  ],
  declarations: [
    SmartValuePipe,
    StringToDateFormatPipe,
    MillisecondsFormatterPipe,
    SideNavBarComponent,
    CompletionBarComponent,
    ViewDocsModalComponent,
    SelectSignatoriesComponent,
    UploadImageModalComponent,
    CreditRatingDetailsComponent,
    UploadButtonComponent,
    ViewCpDocumentsComponent,
    ActionablesComponent,
    LogoutModalComponent,
    UploadSignedDocumentsComponent,
    IciciSelectInputComponent,
    RejectModalComponent,
    ConfirmDialogBoxModalComponent,
    IeBannerComponent,
    IssueListingSidepanelComponent,
    SimpleSigningModalComponent,
    ListingExtradataModalComponent,
    ResendDocsLinkComponent,
    BidSidepanelComponent,
    BidFormComponent,
    DateAdditionalDataComponent,
    UploadSignDocsFormComponent,
    UploadSignDocsSidepanelComponent,
    DateAdditionalDataComponent,
    UploadSignedDocsConfirmComponent,
    PaginationComponent
  ],
  exports: [
    SmartValuePipe,
    StringToDateFormatPipe,
    MillisecondsFormatterPipe,
    FormsModule,
    ReactiveFormsModule,
    SideNavBarComponent,
    CompletionBarComponent,
    ViewDocsModalComponent,
    SelectSignatoriesComponent,
    UploadButtonComponent,
    UploadImageModalComponent,
    ViewCpDocumentsComponent,
    ActionablesComponent,
    LogoutModalComponent,
    IciciSelectInputComponent,
    ConfirmDialogBoxModalComponent,
    IeBannerComponent,
    ResendDocsLinkComponent,
    BidSidepanelComponent,
    UploadSignDocsSidepanelComponent,
    PaginationComponent
  ],
  providers: [
    NgbActiveModal,
  ]
})
export class SharedModule { }
